import moment from "moment";
import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Tab, Tabs, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import "./ExportPlanModal.css"
import { host } from "../../../services/httpService";




function ExportTractorPlan({ show, handleClose, onHide, dataType, dataExportHandler, date, hide, setNoDataState, }) {

  const [FromplanDate, setFromPlanDate] = useState(
    moment().add(1, "days").format("YYYY-MM-DD")
  );
  const [ToplanDate, setToPlanDate] = useState(
    moment().add(1, "days").format("YYYY-MM-DD")
  );

  const [loading, setLoading] = useState('Export');
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [ChangeLoader, setChangeLoader] = useState(false);


  async function dataExportHandler() {


    if (dataType === 'Tractor') {

      try {
        setLoading('Exporting');
        setChangeLoader(true)
        await fetch(
          `${host}GetArybhataMonthlyPlanReport_Tractor?FromDate=${moment(FromplanDate)
            .format("YYYY-MM-DD")}&ToDate=${moment(ToplanDate).format("YYYY-MM-DD")}`,
          {
            method: "GET",
            responseType: "blob",
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        )
          .then((response) => {
            if (response.ok) {
              return response.blob();
          } else{
            setLoading('Export');
            setChangeLoader(false)
            return toast.error("Data not available to perform operation.");
            }
          })
          .then((blob) => {
         
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.download = "Tractor_daily_plan.xlsx";

            link.click();

            window.URL.revokeObjectURL(url);


            onHide();
           

          });


        hide();
      } catch (error) {
      }
    }
    if (dataType === 'Aggregate') {
      
      try {
        setLoading('Exporting');
        setChangeLoader(true)
        await fetch(
          `${host}GetArybhataMonthlyPlanReport_Aggregate?FromDate=${moment(FromplanDate)
            .format("YYYY-MM-DD")}&ToDate=${moment(ToplanDate).format("YYYY-MM-DD")}`,
          {
            method: "GET",
            responseType: "blob",
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        )
          .then((response) => {
            if (response.ok) {
              return response.blob();
            } else {

              setLoading('Export');
              setChangeLoader(false)
              return toast.error("Data not available to perform operation.");

            }
          })
          .then((blob) => {
            
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.download = "Aggregate_daily_plan.xlsx";
            link.click();

            window.URL.revokeObjectURL(url);
            onHide();
            
          });


        hide();
      } catch (error) {
      }
    }
    if (dataType === '5M') {
      try {
        setLoading('Exporting');
        setChangeLoader(true)
        await fetch(
          `${host}GetArybhataMonthlyPlanReport_5M?FromDate=${moment(FromplanDate)
            .format("YYYY-MM-DD")}&ToDate=${moment(ToplanDate).format("YYYY-MM-DD")}`,
          {
            method: "GET",
            responseType: "blob",
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        )
          .then((response) => {
            if (response.ok) {
              return response.blob();
            } else {
              setLoading('Export');
              setChangeLoader(false)
              return toast.error("Data not available to perform operation.");

            }
          })
          .then((blob) => {
            
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.download = "5M_daily_plan.xlsx";
            link.click();

            window.URL.revokeObjectURL(url);
            onHide();
           
          });


        hide();
      } catch (error) {
      }
    }

  }

  return (
    <>
      <Modal show={show} backdrop="static" onHide={onHide} centered>
        <Modal.Body>

          <h4>Download Report</h4>
          <div className="exportWindow__email_container">

            <div className="transporterWindow__recipientName">
              <Form.Group>
                <label className="transporterWindow__columnName_RecipientLabel">
                  From
                </label>
                <Form.Control
                  type="date"
                  className="hiden-in"
                  value={FromplanDate}
                  onChange={(e) => setFromPlanDate(e.target.value)}
                />
              </Form.Group>
            </div>
            <div>
              <Form.Group>

                <label className="transporterWindow__columnName_RecipientLabel">
                  To
                </label>
                <Form.Control
                  type="date"
                  className="hiden-inp"
                  value={ToplanDate}
                  onChange={(e) => setToPlanDate(e.target.value)}
                />
              </Form.Group>

            </div>


          </div>
          <Button
            className="fr btn-sm"

            onClick={() => dataExportHandler(FromplanDate, ToplanDate)}
            disabled={ChangeLoader}

          >
            {loading}
          </Button>
          <Button
            className="fr mr-1 btn-sm"
            variant="outline-primary"
            onClick={() => {
              onHide();
              setLoading(false);
              setDisableSubmit(false);
            }}
          >
            Cancel
          </Button>

        </Modal.Body>
      </Modal>
    </>
  );
}

export default ExportTractorPlan;
